import React, { useEffect, useState } from 'react';
import styles from '../../_css/Pricing.module.css';
import { usePricing } from './PricingContext';
import { effectiveDisplayToIso, PUBLISH_SCOPE_OPTIONS } from './pricingTransforms';
import { Btn } from './shared';
import { notifySuccess } from '../../utils/helper';

// True when the chosen effective date (DD.MM.YYYY) lies after today.
function isFutureEffectiveDate(effectiveFrom) {
  const iso = effectiveDisplayToIso(effectiveFrom);
  if (!iso) return false;
  const now = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  const todayIso = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
  return iso > todayIso;
}

export default function PublishModal() {
  const {
    publishModalOpen,
    setPublishModalOpen,
    effectiveFrom,
    publishScope,
    publish,
    publishing,
  } = usePricing();
  const [comment, setComment] = useState('');

  useEffect(() => {
    if (publishModalOpen) setComment('');
  }, [publishModalOpen]);

  if (!publishModalOpen) return null;

  const close = () => {
    if (!publishing) setPublishModalOpen(false);
  };

  const scopeLabel =
    PUBLISH_SCOPE_OPTIONS.find((opt) => opt.value === publishScope)?.label || publishScope;
  const scheduled = isFutureEffectiveDate(effectiveFrom);

  const confirm = async () => {
    const ok = await publish(comment);
    if (ok) {
      notifySuccess(scheduled ? `Rate card scheduled for ${effectiveFrom}` : 'Rate card published');
    }
  };

  return (
    <div
      className={styles.modalOverlay}
      onClick={close}
      role="presentation"
    >
      <div
        className={styles.modalCard}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="publish-modal-title"
      >
        <div className={styles.modalHead}>
          <h3 id="publish-modal-title">Publish rate card</h3>
          <button
            type="button"
            className={styles.modalClose}
            onClick={close}
            aria-label="Close"
            disabled={publishing}
          >
            &times;
          </button>
        </div>
        <div className={styles.modalBody}>
          <div className={styles.pubInfo}>
            <div className={styles.pubSummary}>Ready to publish current rate card edits</div>
            <div className={styles.pubMeta}>
              Effective {effectiveFrom} · {scopeLabel}
            </div>
            {scheduled && (
              <div className={styles.pubMeta}>
                Takes effect on {effectiveFrom}; until then the rate card shows current prices.
              </div>
            )}
          </div>
          <label className={styles.pubLabel} htmlFor="pub-note">
            Comment <span className={styles.muted} style={{ fontWeight: 400 }}>(saved to change history)</span>
          </label>
          <textarea
            id="pub-note"
            className={styles.pubTextarea}
            rows={4}
            placeholder="Describe what you changed and why…"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            disabled={publishing}
          />
        </div>
        <div className={styles.modalFoot}>
          <Btn ghost onClick={close} disabled={publishing}>
            Cancel
          </Btn>
          <Btn primary onClick={confirm} disabled={publishing}>
            {publishing ? 'Publishing…' : 'Publish'}
          </Btn>
        </div>
      </div>
    </div>
  );
}
